import { Skeleton, Stack } from '@mui/material';
import { useIsMobile } from '@/data/hooks/useIsMobile';

export const AddressBookSkeleton = () => {
	const isMobile = useIsMobile();
	return (
		<Stack width={isMobile ? '100%' : '70%'} direction="column" spacing={0} paddingTop={'18px'}>
			<Skeleton variant="text" width={250} height={43} />

			<Stack width={'100%'} direction={isMobile ? 'column' : 'row'}>
				<Skeleton
					sx={{ marginRight: '15px', marginBottom: '10px', borderRadius: '4px' }}
					variant="rectangular"
					width={'100%'}
					height={180}
				/>
				<Skeleton
					sx={{ marginRight: '15px', marginBottom: '10px', borderRadius: '4px' }}
					variant="rectangular"
					width={'100%'}
					height={180}
				/>
				<Skeleton
					sx={{ marginRight: '15px', marginBottom: '10px', borderRadius: '4px' }}
					variant="rectangular"
					width={'100%'}
					height={180}
				/>
			</Stack>
		</Stack>
	);
};
